(function(window, document, $, undefined){
  

  
    // -----------------------------------------------------------------------------------------------------
    // GO TO TOP button
    // -----------------------------------------------------------------------------------------------------



    var windowHeight, trigger, cookieConsentHeight, buttonBottom;
    var buttonBottom = parseInt($('.go-to-top').css('bottom'));

    // var goToTopScrollResize = debounce(function(){
    //   windowHeight = $(window).height();
    //   cookieConsentHeight = ($('#cookie-consent').css("visibility")=='visible') ? $('#cookie-consent').outerHeight() : 0;
    //   trigger = $(".site-footer .bottom-bar").offset().top; // <------- THIS IS THE TRIGGER FOR THE OBJECT TO STICK THE BUTTON TO
    //   goToTopScroll();
    // },10);
    // $(window).on("resize", goToTopScrollResize);
    var hasShown = false;

    var goToTopScroll = function(){
      if ($(this).scrollTop() > 100) {
        // show
        if(!hasShown) $('.go-to-top').fadeIn(300);
        hasShown = true;
        // if(($(this).scrollTop()+windowHeight) > (trigger+cookieConsentHeight) ){
        //   $('.go-to-top').css('bottom',-(trigger-windowHeight-buttonBottom-$(this).scrollTop()) );
        // } else {
        //   $('.go-to-top').css('bottom',(buttonBottom+cookieConsentHeight+'px'));
        // }
      } else {
        // hide
        if(hasShown) $('.go-to-top').fadeOut(300);
        hasShown = false;
      }
    };
    $(window).on("scroll", goToTopScroll);

    // goToTopScrollResize();




    // Animate the scroll to top
    $('.go-to-top').click(function(event) {
      event.preventDefault();
      $('html, body').animate({scrollTop: 0}, 300);
    });





})(window, document, jQuery);
